import React from "react";
import { ImgV2 } from "../ImgV2";
export const CardInfo = ({ cardImg, cardText }) => (React.createElement("div", { className: "card-info-root" },
    React.createElement(ImgV2, { src: cardImg, alt: cardText }),
    React.createElement("p", { dangerouslySetInnerHTML: {
            __html: cardText || "",
        } })));
